export default __webpack_public_path__ + "static/slide_6-9516c1850c341aff4a52f440c3415595.png";